import { render, staticRenderFns } from "./RelatorioRupturaListRoute.vue?vue&type=template&id=304f9460"
import script from "./RelatorioRupturaListRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioRupturaListRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports